import { createIcon } from '../icon'
import ReturnIconPlain from '../svg/ReturnIconPlain'

export const ReturnIconPlainDefault = createIcon(ReturnIconPlain)
